import { useEffect } from "react";

/*
  When using google translate to translate the page, it replaces some nodes.
  When react tries to remove those or add new ones, it throws an error.
  This is a hacky way to fix it.
  Downsides: Slight performance degradation and potentially obfuscating actual bugs.
  Code copied from: https://github.com/facebook/react/issues/11538#issuecomment-417504600
*/

export const FixGoogleTranslate = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  useEffect(() => {
    if (typeof Node === "function" && Node.prototype) {
      // eslint-disable-next-line @typescript-eslint/unbound-method
      const originalRemoveChild = Node.prototype.removeChild;
      Node.prototype.removeChild = function <T extends Node>(child: T): T {
        if (child.parentNode !== this) {
          if (console) {
            console.error(
              "Cannot remove a child from a different parent",
              child,
              this
            );
          }
          return child;
        }
        return originalRemoveChild.apply(this, [child]) as T;
      };

      // eslint-disable-next-line @typescript-eslint/unbound-method
      const originalInsertBefore = Node.prototype.insertBefore;
      Node.prototype.insertBefore = function <T extends Node>(
        newNode: T,
        referenceNode: Node | null
      ): T {
        if (referenceNode && referenceNode.parentNode !== this) {
          if (console) {
            console.error(
              "Cannot insert before a reference node from a different parent",
              referenceNode,
              this
            );
          }
          return newNode;
        }
        return originalInsertBefore.apply(this, [newNode, referenceNode]) as T;
      };
    }
  }, []);
  return <>{children}</>;
};
